import Api from "../../services/Api";

export async function getListCountryService() {
    return Api().get('pays/all');
}
